/*
 * Copyright (c) 2023 Supre  <https://www.supre.com.co>
 *
 * All Rights Reserved
 * This product is protected by copyright and distributed under
 * licenses restricting copying, distribution and decompilation.
 */

/**
Created by  José Nicolás Pereira 12/9/23
@author : José Nicolás Pereira <jpereira@supre.com.co>
@date : 12/9/23
@project : omnia-site
*/

export const DataTreatment = () => {
  return (
    <div>
      <p className="paragraphs">
        Dando cumplimiento a lo dispuesto en la Ley 1581 de 2012, "Por el cual
        se dictan disposiciones generales para la protección de datos
        personales" y de conformidad con lo señalado en el Decreto 1377 de 2013,
        con la firma de este documento manifiesto que de forma previa e
        informada a la recolección de mis datos personales se me comunicó el
        objeto de la solicitud de mi información personal, por ende, al ingresar
        a este sitio se han puesto a disposición los términos y condiciones de
        uso, los cuales conozco y aceptó, por lo que autorizo a{" "}
        <b>Suprecredito S.A.S.</b> (en adelante Suprecredito), o a quienes
        representen sus derechos en el futuro en calidad de acreedor, para
        efectuar el tratamiento de mis datos personales, incluyendo la
        recolección, almacenamiento, actualización, uso, circulación,
        transmisión, transferencia y supresión de los mismos, para los
        siguientes fines:
      </p>
      <ol className="c-list-1">
        <li className="paragraphs">
          <p className="paragraphs">
            Recolecte, recaude, almacene, use, circule, suprima, procese,
            compile, trate, actualice y cruce mis datos, con información propia,
            así como mis datos de contacto incluyendo direcciones, teléfonos y
            correos electrónicos, datos de escolaridad, información financiera,
            sociodemográfica.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Utilice cookies propias y de terceros para obtener datos de mi
            navegación, con el objetivo de ofrecerme un servicio personalizado y
            para obtener datos estadísticos de la navegación.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Compartir los datos personales con las autoridades (judiciales o
            administrativas) que tengan facultad para solicitar los datos, en
            ejecución de un mandato administrativo o judicial o en cumplimiento
            de una ley.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Realizar las gestiones contables pertinentes como el envío de
            facturas y cobros relacionados conforme a la legislación.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Incluir mi información en bases de datos para estudios estadísticos,
            procesos de facturación, análisis de mercado.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Administración de riesgos de Lavado de Activos y Financiación del
            Terrorismo.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Gestionar toda la información necesaria para el cumplimiento de las
            obligaciones contractuales y legales en relación con las actividades
            de Suprecredito.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Envío de mis datos, a las autoridades competentes que lo soliciten
            y/o a terceros autorizados como encargados para que sean
            administrados, transferidos y transmitidos en Colombia y/o en otros
            países que proporcionen medidas de protección de datos equiparables.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Consultar, en cualquier tiempo, en las centrales de riesgo toda la
            información relevante para conocer mi desempeño como deudor, mi
            capacidad de pago o para valorar el riesgo futuro de concederme un
            crédito y/o cualquier otro servicio financiero.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Reportar en las centrales de riesgo, directamente o por intermedio
            de las entidades públicas que ejercen funciones de vigilancia y
            control, datos tratados o sin tratar, referidos al ccumplimiento
            oportuno e incumplimiento, de mis obligaciones crediticias, deberes
            constitucionales y legales de contenido patrimonial, de tal forma
            que estas presenten una información veraz, pertinente, completa,
            actualizada y exacta de mi desempeño como deudor después de haber
            cruzado y procesado diversos datos útiles para obtener una
            información significativa.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Administrar el riesgo de Lavado de Activos y Financiación del
            Terrorismo y de corrupción.
          </p>
        </li>
      </ol>
      <h2 className="o-heading-4">Aceptaciones y Declaraciones</h2>
      <ol className="c-list-1">
        <li className="paragraphs">
          <p className="paragraphs">
            No responsabilidad de permanencia de información en centrales:
            reconozco y acepto que Suprecredito no es responsable
            de los periodos de permanencia de tal información en los bancos de
            datos, toda vez que su obligación es la actualización de los
            reportes efectuados.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Derechos del titular: usted, como titular de los datos personales,
            tiene derecho a conocer, actualizar y corregir sus datos personales.
            Podrá materializar estos derechos mediante el procedimiento,
            enviando la solicitud al correo servicioalcliente@supre.com.co o
            puede solicitar una comunicación telefónica, enviando su número de
            contacto a ese mismo correo. De igual forma, mediante la página web
            de Suprecredito
            <a href="https://supre.com.co/"> https://supre.com.co/</a> podré
            radicar cualquier tipo de requerimiento relacionado con el
            tratamiento de mis datos personales.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Mensaje de datos: la información contenida en el presente documento
            goza de plena validez a la luz del artículo 5 de la Ley 527 de 1999,
            por medio del cual se reconoce jurídicamente los efectos de los
            mensajes de datos.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Política de tratamiento de datos: declaro conocer y haber leído en
            su integridad la política de privacidad, la cual se encuentra
            disponible en el sitio{" "}
            <a href="https://supre.com.co/politicas/privacidad-de-datos/">
              https://supre.com.co/politicas/
            </a>{" "}
            la cual forma parte integral de la presente autorización. Las
            condiciones aquí descritas y la política de privacidad podrán ser
            objeto de modificación de conformidad con el apartado del presente
            documento. Suprecredito garantizará la confidencialidad,
            libertad, seguridad, veracidad, transparencia, acceso y circulación
            restringida de mis datos y se reservará el derecho de modificar su
            Política de tratamiento de Datos Personales en cualquier momento.
            Cualquier cambio será informado y publicado oportunamente en la
            página web.
          </p>
        </li>
      </ol>
      <p className="paragraphs">
        Teniendo en cuenta lo anterior, autorizo de manera voluntaria, previa,
        explícita, informada e inequívoca a Suprecredito para
        tratar mis datos personales y tomar mi huella y fotografía de acuerdo
        con su Política de tratamiento de Datos Personales para los fines
        relacionados con su objeto y en especial para fines legales y
        contractuales descritos en la Política de tratamiento de Datos
        Personales de Suprecredito, dejando claridad que la
        información obtenida para el tratamiento de mis datos personales la he
        suministrado de forma voluntaria y es verídica.
      </p>
    </div>
  );
};
